import { render, staticRenderFns } from "./recipe-ingredient-tab.vue?vue&type=template&id=d2479102&"
import script from "./recipe-ingredient-tab.vue?vue&type=script&lang=js&"
export * from "./recipe-ingredient-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports